import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

function NotFound() {
	return (
		<>
			<Helmet>
				<title>Page Not Found | A-Z Home Improvement LLC</title>
				<meta name="robots" content="noindex" />
			</Helmet>
			<div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' }}>
				<div style={{ textAlign: 'center', maxWidth: 500 }}>
					<div style={{ fontSize: 72, fontWeight: 900, color: 'var(--brand)', lineHeight: 1, marginBottom: 10 }}>404</div>
					<h1 style={{ fontSize: 26, marginBottom: 12 }}>Page Not Found</h1>
					<p className="helper" style={{ marginBottom: 24 }}>The page you're looking for doesn't exist or may have been moved. Let's get you back on track.</p>
					<div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
						<Link to="/" className="btn">Go to Homepage</Link>
						<Link to="/contact" className="btn-outline">Contact Us</Link>
					</div>
				</div>
			</div>
		</>
	);
}

export default NotFound;
